import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=b94c0a4a&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=b94c0a4a&prod&scoped=true&lang=css"
import style1 from "./UserManagement.vue?vue&type=style&index=1&id=b94c0a4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94c0a4a",
  null
  
)

export default component.exports